export var Recurrence;
(function (Recurrence) {
    Recurrence["NONE"] = "NONE";
    Recurrence["DAILY"] = "DAILY";
    Recurrence["WEEKLY"] = "WEEKLY";
    Recurrence["MONTHLY"] = "MONTHLY";
})(Recurrence || (Recurrence = {}));
